var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"business-info"},[_c('img',{attrs:{"src":_vm.businessImgUrl,"alt":""}}),_vm._v(" "),_c('h3',{staticClass:"business-name"},[_vm._v(_vm._s(_vm.businessName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f1e895","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/child-components/publicBusinessInfo.vue
// module id = null
// module chunks = 